import { getConditionalObject } from 'utils/data';

export const getMaskInputStyles = (isMasked = false) => ({
  '&[data-is-mask="true"]': {
    position: 'relative',
    fontFamily: '"Roboto Mono", monospace',
    textDecoration: 'none',
    padding: '9px 12px !important',

    ...getConditionalObject(isMasked, {
      color: 'transparent !important',

      '&::selection': {
        color: 'transparent',
        backgroundColor: '#4366D2 !important',
      },
    }),

    '&:disabled': {
      WebkitTextFillColor: 'unset',
    },

    '&:-webkit-autofill': {
      boxShadow: 'unset !important',
      textFillColor: ({ palette }) =>
        `${isMasked ? 'transparent' : palette.text.primary} !important`,
      color: ({ palette }) => `${isMasked ? 'transparent' : palette.text.primary} !important`,
      caretColor: ({ palette }) => palette.text.primary,
    },
  },
});

const multilineScrollStyles = {
  '& .MuiInputBase-inputMultiline': {
    overflowY: 'auto',
  },
};

export const getTextFieldStyles = ({ sx, multiline, rows, isScrollable }) => ({
  ...sx,
  ...(isScrollable && multiline && rows && multilineScrollStyles),
});

export const customHelperStyles = {
  position: 'absolute',
  top: '100%',
  left: 0,
  width: '100%',
  paddingTop: '4px',
  zIndex: 1,
};

export const maskInputStyles = {
  position: 'absolute',
  pointerEvents: 'none',
  height: '40px',
  bottom: 0,
  left: 0,
  border: '1px solid transparent',
};
